import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const createDynamicNode = (data) => {
  const url = `${BASE_URL}node/output/data/`;
  const headers = {
    'x-haptik-bot-name': data.domain_name,
  };
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};

export const fetchDynamicNodeData = (nodeId) => {
  const url = `${BASE_URL}node/output/data/${nodeId}/?version=3`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveDynamicNodeData = (nodeId, data) => {
  const url = `${BASE_URL}node/output/data/${nodeId}/`;
  const headers = {
    'x-haptik-bot-name': data.domain_name,
  };
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};
